/**
 * Prevenção de dupla submissão de formulários
 * Aplicável a todos os formulários do site
 */

document.addEventListener('DOMContentLoaded', function () {
    // Seletor para todos os formulários que devem ter proteção
    const formsToProtect = [
        '#form-modal-coordenador',
        '#representative',
        '#agreements',
        '.validate-jquery',
        '.requires-captcha',
        'form[data-prevent-double="true"]'
    ];

    formsToProtect.forEach(selector => {
        const forms = document.querySelectorAll(selector);
        
        forms.forEach(form => {
            if (!form.dataset.protectionAdded) {
                addDoubleSubmitProtection(form);
                form.dataset.protectionAdded = 'true';
            }
        });
    });
});

/**
 * Adiciona proteção contra dupla submissão a um formulário
 */
function addDoubleSubmitProtection(form) {
    let isSubmitting = false;
    let originalButtonContent = {};
    
    form.addEventListener('submit', function(e) {
        // Se já está enviando, prevenir nova submissão
        if (isSubmitting) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
        
        // Marcar como enviando
        isSubmitting = true;
        
        // Encontrar todos os botões de submit
        const submitButtons = form.querySelectorAll('button[type="submit"], input[type="submit"]');
        
        submitButtons.forEach(button => {
            // Guardar conteúdo original
            originalButtonContent[button.id || Math.random()] = button.innerHTML;
            
            // Desabilitar botão
            button.disabled = true;
            button.style.opacity = '0.6';
            button.style.cursor = 'not-allowed';
            
            // Adicionar indicador de loading
            if (button.tagName === 'BUTTON') {
                const hasIcon = button.querySelector('i');
                if (hasIcon) {
                    button.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Enviando...';
                } else {
                    button.innerHTML = 'Enviando...';
                }
            } else {
                button.value = 'Enviando...';
            }
        });
        
        // Adicionar overlay de loading no formulário
        const overlay = document.createElement('div');
        overlay.className = 'form-loading-overlay';
        overlay.style.cssText = `
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(255, 255, 255, 0.8);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 9999;
        `;
        overlay.innerHTML = `
            <div style="text-align: center;">
                <i class="fas fa-spinner fa-spin" style="font-size: 2em; color: #dc3545;"></i>
                <p style="margin-top: 10px; color: #333;">Processando sua solicitação...</p>
            </div>
        `;
        
        // Se o formulário está em um modal, adicionar overlay ao modal
        const modal = form.closest('.modal-body');
        if (modal) {
            modal.style.position = 'relative';
            modal.appendChild(overlay);
        } else {
            form.style.position = 'relative';
            form.appendChild(overlay);
        }
        
        // Timeout de segurança (30 segundos)
        setTimeout(function() {
            if (isSubmitting) {
                resetForm();
            }
        }, 30000);
        
        // Função para resetar o formulário
        function resetForm() {
            isSubmitting = false;
            
            // Remover overlay
            if (overlay && overlay.parentNode) {
                overlay.parentNode.removeChild(overlay);
            }
            
            // Restaurar botões
            submitButtons.forEach(button => {
                button.disabled = false;
                button.style.opacity = '1';
                button.style.cursor = 'pointer';
                
                const originalContent = originalButtonContent[button.id || Object.keys(originalButtonContent)[0]];
                if (originalContent) {
                    if (button.tagName === 'BUTTON') {
                        button.innerHTML = originalContent;
                    } else {
                        button.value = originalContent.replace(/<[^>]*>/g, '');
                    }
                }
            });
        }
        
        // Se o formulário está em um modal Bootstrap, resetar quando fechar
        const modalElement = form.closest('.modal');
        if (modalElement) {
            $(modalElement).on('hidden.bs.modal', resetForm);
        }
    });
}

// Exportar para uso global
window.addDoubleSubmitProtection = addDoubleSubmitProtection;